var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "IC_4L_main",
    className: "IC_4L_main",
    d: "M4.8 22.6V9c0-.7.5-1.2 1.2-1.2h11.2c2.2 0 4 1.8 4 4v.9h15.2c.7 0 1.2.5 1.2 1.2v19.8c0 .7-.5 1.2-1.2 1.2L6 34.8c-.7 0-1.2-.5-1.2-1.2V18.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 14.9,
    cy: 23.3,
    r: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.3,
    cy: 23.4,
    r: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 27.6,
    cy: 23.3,
    r: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOther);
export default __webpack_public_path__ + "static/media/folderOther.18e5f01281a6150c807a340ed7df784d.svg";
export { ForwardRef as ReactComponent };